/* global femcare */

$(document).ready(function () {
    femcare.ctaPanel.quickBuy.init();
});

$(window).on('load', function () {
    femcare.product.cart.init().then(function () {
        femcare.product.panel.info.default.init();
        femcare.product.panel.info.shop.init();
        femcare.product.panel.info.slider.init();
        femcare.ctaPanel.colorSelector.init();
    });
});
